const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-StaticLabel',
			Template: /*HTML*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<!-- preserved for spacing when labels are used in sibling cells - use "HideLabel" to remove this invisible spacing -->
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">&nbsp;</label>
					<input id="{~D:Record.Macro.RawHTMLID~}" type="hidden" {~D:Record.Macro.InputFullProperties~} />
					<!-- Actual label is displayed in the reserved space of the typical input area -->
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static {~ColumnAlignment:Record~}">
						<div {~D:Record.Macro.ControlAttr~} class="label">{~LabelWithChips:Record~}</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
					/>
				<p class="control">
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static {~ColumnAlignment:Record~}">
						<label {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
				</p>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-StaticLabel',
			Template: /*HTML*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<!-- preserved for spacing when labels are used in sibling cells - use "HideLabel" to remove this invisible spacing -->
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">&nbsp;</label>
					<input id="{~D:Record.Macro.RawHTMLID~}" type="hidden" {~D:Record.Macro.InputFullProperties~} />
					<!-- Actual label is displayed in the reserved space of the typical input area -->
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static {~ColumnAlignment:Record~}">
						<div {~D:Record.Macro.ControlAttr~} class="label">{~LabelWithChips:Record~}</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
					/>
				<p class="control">
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static {~ColumnAlignment:Record~}">
						<label {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
				</p>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-StaticLabel',
			Template: /*HTML*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<!-- preserved for spacing when labels are used in sibling cells - use "HideLabel" to remove this invisible spacing -->
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">&nbsp;</label>
					<input id="{~D:Record.Macro.RawHTMLID~}" type="hidden" {~D:Record.Macro.InputFullProperties~} />
					<!-- Actual label is displayed in the reserved space of the typical input area -->
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static {~ColumnAlignment:Record~}">
						<div {~D:Record.Macro.ControlAttr~} class="label">{~LabelWithChips:Record~}</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
			<!-- InputType StaticLabel {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-StaticLabel',
			Template: /*HTML-Partial*/`
					/>
				<div class="control">
					<div id="LABEL-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static {~ColumnAlignment:Record~}">
						<label {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
